import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openOrderDetailsUrl,
  updateOrderPaymentStatus,
  sendOrderEmailToBuyer,
  redundModalCall,
} from "TicketAction";
import {
  COMMON_FAIL_MESSAGE,
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  converDateIntoLocal,
  DEVELOPMENT_TYPE,
  DOMAIN_NAME,
} from "Constants";
import LocaleStrings from "Languages";

class OrderListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, loadingOrderEmail: false };
  }

  openModal = () => {
    // this.props.openOrderDetailsUrl(true, this.props.order.orderid);
    let seocode =
      this.props.eventDetails && this.props.eventDetails.seocode
        ? this.props.eventDetails.seocode
        : "not-found-seocode";

    var websiteurl = `https://${seocode}.${DOMAIN_NAME}/t/tickets/ticketorder/${this.props.order.orderid}`;

    window.open(websiteurl, "_blank");
  };

  acceptPayment = () => {
    let { session, order } = this.props;
    let values = {
      orderid: order.id,
      eventid: order.eventid,
      type: "paylater_payment_admin_confirm",
    };

    confirmAlert({
      title: LocaleStrings.tickets_salesreport_title_payment_accepted,
      message:
        LocaleStrings.tickets_salesreport_text_sure_want_to_accept_payment,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.setState({ loading: true });
            this.props.updateOrderPaymentStatus(session, values, (response) => {
              this.setState({ loading: false });
              if (response.success === 1) {
                this.props.showSuccess(
                  LocaleStrings.tickets_salesreport_payment_accepted_success
                );
              } else if (response.success === 2) {
                if (response.data.code === "eventid_required") {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_eventid_required
                  );
                } else if (response.data.code === "orderid_required") {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_orderid_required
                  );
                } else if (response.data.code === "invalid_orderid") {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_invalid_orderid
                  );
                } else if (response.data.code === "order_already_confirmed") {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_order_already_confirmed
                  );
                } else if (
                  response.data.code === "user_have_other_access_permission"
                ) {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_other_permission
                  );
                } else if (
                  response.data.code ===
                  "email_already_assigned_with_current_ticket"
                ) {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_already_assigned
                  );
                } else if (
                  response.data.code === "email_not_associated_with_event"
                ) {
                  this.props.showError(
                    LocaleStrings.tickets_salesreport_payment_accepted_error_email_not_associated_with_event
                  );
                } else if (
                  response.data.code ===
                  "assigned_attendee_have_other_access_permission"
                ) {
                  this.props.showError(
                    _.replace(
                      LocaleStrings.tickets_salesreport_payment_accepted_error_assigned_attendee_have_other_access_permission,
                      "#emails",
                      response?.data?.resource?.emails
                    )
                  );
                } else if (
                  response.data.code ===
                  "assigned_attendee_already_assigned_with_current_ticket"
                ) {
                  this.props.showError(
                    _.replace(
                      LocaleStrings.tickets_salesreport_payment_accepted_error_assigned_attendee_already_assigned_with_current_ticket,
                      "#emails",
                      response?.data?.resource?.emails
                    )
                  );
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
              } else {
                this.props.showError(COMMON_FAIL_MESSAGE);
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  resendOrderEmail = (e) => {
    let { session, order } = this.props;
    e.preventDefault();
    e.stopPropagation();

    let values = { orderid: order.orderid };
    // console.log("values :- ", values);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>
              {LocaleStrings.tickets_salesreport_title_resend_order_email}
            </h1>
            <p>
              {
                LocaleStrings.tickets_salesreport_text_sure_want_to_resend_order_email
              }
            </p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.setState({ loadingOrderEmail: true });
                  onClose();
                  this.props.sendOrderEmailToBuyer(
                    session,
                    values,
                    (response) => {
                      this.setState({ loadingOrderEmail: false });
                      if (response.success === 1) {
                        this.props.showSuccess(
                          LocaleStrings.tickets_salesreport_resend_order_email_success
                        );
                      } else {
                        this.props.showError(
                          LocaleStrings.tickets_salesreport_payment_accepted_error_invalid_orderid
                        );
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_yes}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_no}</button>
            </div>
          </div>
        );
      },
    });
  };

  openRefundModal = () => {
    let { order } = this.props;
    console.log(order);

    this.props.redundModalCall({ show: true, orderDetails: order });
  };

  render() {
    var { order } = this.props;
    var { loadingOrderEmail } = this.state;

    var purchaseDate = converDateIntoLocal(order.createdon);
    var invoiceUrl = `${BASE_IMAGES_URL}/eventify/${order.eventid}/invoice/order-${order.orderid}.pdf?api_key=${ACCESS_FILES_API_KEY}&download=true`;
    if (
      order.paymentmethod == "paylater" &&
      order.paymentstatus == "pending" &&
      order.status == "pending"
    ) {
      invoiceUrl = `${BASE_IMAGES_URL}/eventify/${order.eventid}/invoice/order-off-${order.orderid}.pdf?api_key=${ACCESS_FILES_API_KEY}&download=true`;
    }
    var amount = this.props.order.customeramount;
    var discount = this.props.order.discount;

    let ticketname = "";
    if (
      order.tickets_by_orderdetails &&
      order.tickets_by_orderdetails.length > 0
    ) {
      ticketname = order.tickets_by_orderdetails[0].ticketname;
    } else if (order.ticketname) {
      ticketname = order.ticketname;
    }

    return order.paymentmethod == "payfast" &&
      order.status != "approve" ? null : (
      <tr>
        <td>
          <div className="vcenter">{order.orderid}</div>
        </td>
        <td>
          <div className="vcenter">{order.email}</div>
        </td>
        {DEVELOPMENT_TYPE === "koachify" ? (
          <td>
            <div className="vcenter">{ticketname}</div>
          </td>
        ) : (
          <td>
            <div className="vcenter">{order.total_quantity}</div>
          </td>
        )}
        <td>
          <div className="vcenter">{purchaseDate}</div>
        </td>
        <td>
          <div className="vcenter">
            {order.currency}{" "}
            {(parseFloat(amount) + parseFloat(discount)).toFixed(2)}
          </div>
        </td>
        <td>
          <div className="vcenter">
            {order.currency} {parseFloat(discount).toFixed(2)}
          </div>
        </td>
        <td>
          <div className="vcenter">
            {order.currency} {parseFloat(amount).toFixed(2)}
          </div>
        </td>
        <td>
          <div className="table-ation-td">
            {order.paymentmethod == "paylater" &&
            order.paymentstatus == "pending" &&
            order.status == "pending" ? (
              <Button
                className="btn btn-custom-blue"
                onClick={this.acceptPayment}
                loading={this.state.loading}
                disabled={this.state.loading}
                type="button"
              >
                {LocaleStrings.button_maked_paid}
              </Button>
            ) : (
              ""
            )}

            {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <button
                type="button"
                onClick={this.openModal}
                className="btn btn-custom-table-white"
              >
                {LocaleStrings.button_view}
              </button>
            )}

            <a href={invoiceUrl} target="_blank" download>
              <button type="button" className="btn btn-custom-table-white">
                {LocaleStrings.button_get_invoice}
              </button>
            </a>
            <button
              type="button"
              onClick={loadingOrderEmail ? null : this.resendOrderEmail}
              className={`btn btn-custom-table-white ${
                loadingOrderEmail ? "cursor-wait" : ""
              }`}
              disabled={loadingOrderEmail}
            >
              {loadingOrderEmail ? (
                <i
                  className="fa fa-spinner icn-spinner"
                  aria-hidden="true"
                  style={{ marginRight: 2 }}
                />
              ) : (
                ""
              )}
              {LocaleStrings.button_order_email}
            </button>

            {/* {DEVELOPMENT_TYPE === "koachify" ? (
              ""
            ) : (
              <>
                {order.status === "approve" ? (
                  <button
                    type="button"
                    onClick={this.openRefundModal}
                    className="btn btn-custom-table-white"
                  >
                    {LocaleStrings.button_refund}
                  </button>
                ) : (
                  ""
                )}
              </>
            )} */}
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openOrderDetailsUrl,
  updateOrderPaymentStatus,
  sendOrderEmailToBuyer,
  redundModalCall,
})(OrderListItem);
